import React from "react";
import { useTheme, useMediaQuery } from '@mui/material';
import { DataGrid } from "@mui/x-data-grid";
import CustomDataGridToolbar from "components/CustomDataGridToolbar";


const DataGridComponent = ({
    rows,
    columns,
    columnVisibilityModel,
    setColumnVisibilityModel,
    loading,
    showSearch = true,
    props,
    sx = {},
}) => {
    const theme = useTheme();
    const isExpanded = useMediaQuery(theme.breakpoints.up('lg'));

    return (
        <DataGrid
            getRowId={(row) => row._id}
            rows={rows || []}
            columns={columns}
            pageSizeOptions={[25, 50, 100]}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel?.(newModel)}
            loading={loading}
            density="standard"
            showToolbar
            slots={{ toolbar: () => <CustomDataGridToolbar isExpanded={isExpanded} showSearch={showSearch} /> }}
            {...props}
            sx={{ height: "100%", ...sx }}
        />
    );
};

export default DataGridComponent;
